import { AppLayout } from "../shared";
import Dashboard from "../Dashboard/Dashboard";

const Dashboard_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <Dashboard props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default Dashboard_layout;